const id_common_report = {
    payment_type: "tipe pembayaran",

    do: {
        "": "delivery order",
        detail: "detail delivery order",
    },
    delivery: {
        "": "pengiriman",
        label: {

        }
    },

    group: {
        "": "grup",
        label: {

        }
    },

    hpp: {
        "": "HPP penjualan",
        total: "total HPP penjualan",
        label: {
        }
    },

    purch: {
        "": "pembelian",
        label: {

        }
    },
    payment_sales: {
        "": "pembayaran penjualan",
        label: {

        }
    },
    payment_purch: {
        "": "pembayaran pembelian",
        label: {

        }
    },

    return_cus: {
        "": "retur penjualan",
        total: "total nominal retur penjualan",
    },
    return_sup: {
        "": "retur pembelian",
        total: "total nominal retur pembelian",
    },

    sales: {
        "": "penjualan",
        detail: "detail penjualan",
    },
    sales_commission: {
        "": "komisi penjualan",
        total: "total komisi penjualan",
        label: {
            total: "total komisi"
        }
    },
    stock_price: {
        "": "nilai stok barang",
        label: {
            nominal: "nilai barang",
            total_nominal: "total nilai barang",
        },
    },
    so: {
        "": "sales order",
        detail: "detail sales order",
        label: {
            type: "tipe SO",
            status: "status SO",
            status_item: "status barang",
        }
    },
}

export default id_common_report;